// src/pages/Signup.js
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/signup.css';
import VoucherWelcomeModal from '../components/VoucherWelcomeModal';

const API_BASE = "";

function Signup() {
    const navigate = useNavigate();
    const [signupError, setSignupError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    
    const [showWelcomeModal, setShowWelcomeModal] = useState(false);
    const [voucherInfo, setVoucherInfo] = useState({ voucherCode: null, email: '' });
    
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [city, setCity] = useState('');
    const [cellNumber, setCellNumber] = useState('');

    useEffect(() => {
        const isAuthenticated = localStorage.getItem("isAuthenticated");
        if (isAuthenticated === "true") {
            console.log("User already authenticated, redirecting...");
            navigate("/checkout");
        }
    }, [navigate]);

    const handleFormSignup = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        setSignupError("");

        if (password !== confirmPassword) {
            setSignupError("Passwords do not match.");
            setIsLoading(false);
            return;
        }

        try {
            console.log("Attempting form-based signup via backend API...");
            const signupResponse = await fetch(`${API_BASE}/api/signup`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name, surname, email, password, city, cellNumber }),
            });

            if (signupResponse.ok) {
                const responseData = await signupResponse.json();
                console.log("User successfully created via form.", responseData);

                if (responseData.voucherCode) {
                    setVoucherInfo({ voucherCode: responseData.voucherCode, email: email });
                    setShowWelcomeModal(true);
                } else {
                    navigate('/login');
                }
            } else {
                const contentType = signupResponse.headers.get("content-type");
                if (contentType && contentType.indexOf("application/json") !== -1) {
                    const errorData = await signupResponse.json();
                    setSignupError(errorData.error || "Signup failed due to a server error.");
                } else {
                    const errorText = await signupResponse.text();
                    console.error("Non-JSON error response:", errorText);
                    setSignupError("An unexpected server error occurred. Please try again later.");
                }
            }
        } catch (error) {
            console.error("Signup process failed:", error);
            setSignupError("Could not connect to the server. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };
    
    const handleCloseWelcomeModal = () => {
        setShowWelcomeModal(false);
        navigate('/login');
    };

    return (
        <div className="signup-container">
            <div className="auth-card">
                <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">Create Your Account</h2>
                
                <form className="signup-form" onSubmit={handleFormSignup}>
                    <div className="form-group">
                        <label htmlFor="name">Name</label>
                        <input type="text" id="name" name="name" placeholder="Enter your name" required disabled={isLoading} value={name} onChange={(e) => setName(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="surname">Surname</label>
                        <input type="text" id="surname" name="surname" placeholder="Enter your surname" required disabled={isLoading} value={surname} onChange={(e) => setSurname(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input type="email" id="email" name="email" placeholder="Enter your email" required disabled={isLoading} value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Create Password</label>
                        <div className="password-input-container">
                            <input type={showPassword ? "text" : "password"} id="password" name="password" placeholder="Minimum 6 characters" required disabled={isLoading} value={password} onChange={(e) => setPassword(e.target.value)} />
                            <button type="button" className="password-toggle" onClick={() => setShowPassword(!showPassword)} disabled={isLoading}>
                                {showPassword ? "Hide" : "Show"}
                            </button>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="confirmPassword">Confirm Password</label>
                        <div className="password-input-container">
                            <input type={showConfirmPassword ? "text" : "password"} id="confirmPassword" name="confirmPassword" placeholder="Confirm your password" required disabled={isLoading} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                            <button type="button" className="password-toggle" onClick={() => setShowConfirmPassword(!showConfirmPassword)} disabled={isLoading}>
                                {showConfirmPassword ? "Hide" : "Show"}
                            </button>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="city">Current City/Town</label>
                        <input type="text" id="city" name="city" placeholder="Enter your city/town" required disabled={isLoading} value={city} onChange={(e) => setCity(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="cellNumber">Cell Number</label>
                        <input type="tel" id="cellNumber" name="cellNumber" placeholder="e.g., 0821234567" required disabled={isLoading} value={cellNumber} onChange={(e) => setCellNumber(e.target.value)} />
                    </div>
                    {signupError && <div className="error-message">{signupError}</div>}
                    <button type="submit" className="submit-button" disabled={isLoading}>
                        {isLoading ? "Creating Account..." : "Sign Up"}
                    </button>
                </form>

                <p className='login-link'>
                    Already have an account? <Link to="/login">Login Here</Link>
                </p>
            </div>
            {isLoading && <div className="loading-overlay"><div className="spinner"></div></div>}
            
            {showWelcomeModal && (
                <VoucherWelcomeModal
                    voucherCode={voucherInfo.voucherCode}
                    userEmail={voucherInfo.email}
                    onClose={handleCloseWelcomeModal}
                />
            )}
        </div>
    );
}

export default Signup;
